import type { ChangeEvent, FC } from "react";

import { TextareaInputStyle } from "../../../../documentation/styles/InputStyle";
import type { FormInputProps } from "../../types/types";

/**
 * Defines how many rows (height) have the Textarea components by default.
 * This value can be override by using the field properties defined in the json file.
 */
interface TextareaProps extends FormInputProps<string> {
    readOnly: boolean;
    onBlur?: () => void;
    noWrap?: boolean;
}

export const Textarea: FC<TextareaProps> = ({ onChange, readOnly, onBlur, noWrap, ...rest }) => {
    const onValueChange = (ev: ChangeEvent<HTMLTextAreaElement>) => {
        if (onChange) {
            onChange(ev.target.value);
        }
    };

    const classNames = ["aevi-input", "aevi-input-textarea"];
    if (noWrap) {
        classNames.push("aevi-input-textarea-nowrap");
    }
    if (readOnly) {
        classNames.push("aevi-input-disabled");
    }

    return <TextareaInputStyle className={classNames.join(" ")} disabled={readOnly} onChange={onValueChange} onBlur={onBlur} {...rest} />;
};
